import { default as AboutUs } from "./about-us-root";

export default AboutUs;
